import React, { Component } from 'react';
import { Flex } from "rebass";
import { CircleButton, FlexWrapper } from './styles';
import MdAdd from 'react-ionicons/lib/MdAdd';

class RosterActions extends Component {
	state = {
		active: false,
		toggleWidth: false
	}

	toggleButton = () => {
		this.setState({
			active: !this.state.active
		})

		if (this.state.toggleWidth === false) {
			this.setState({
				toggleWidth: !this.state.toggleWidth
			});
		} else {
			setTimeout(() => {
				this.setState({
					toggleWidth: !this.state.toggleWidth
				})
			}, 400);
		}
	}

	render() {
		const { children, onClick } = this.props;
		const childrenWithExtraProp = React.Children.map(children, child => {
      		return child && React.cloneElement(child, {	
       		 active: this.state.active
      	});
    });
	
		return (
			<FlexWrapper alignItems={'center'} onClick={onClick} active={this.state.toggleWidth}>
				<CircleButton active={this.state.active} onClick={this.toggleButton}><MdAdd color={'white'} fontSize={'16px'} /></CircleButton>
				<Flex alignItems={'center'}>
					{childrenWithExtraProp}
				</Flex>
			</FlexWrapper>
		);
	}
}

export default RosterActions